import React from 'react';

import { MUIModal } from 'Components/Base';
import { FeedbackReportForm, FeedbackReportComplete } from 'Components/Feedback';

const FeedbackReportModal = ({
  isSuccess,
  loading,
  options,
  onSubmit,
  onOpenModal,
  onCloseModal,
  toggleComponent,
}) => {
  return (
    <MUIModal
      onOpenModal={onOpenModal}
      onCloseModal={onCloseModal}
      toggleComponent={React.isValidElement(toggleComponent) && toggleComponent}
      modalStyle={{ padding: '36px', borderRadius: '16px', maxWidth: '340px' }}
    >
      {(openModal, closeModal) => {
        if (isSuccess) return <FeedbackReportComplete onContinue={closeModal} />;
        return (
          <FeedbackReportForm onSubmit={onSubmit} feedbackOptions={options} loading={loading} />
        );
      }}
    </MUIModal>
  );
};

export default FeedbackReportModal;
